import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import moment from 'moment';
import 'moment/locale/de';

class FirstProgramInfoDialog extends React.Component {

  render() {
    const { fullScreen } = this.props;
    moment.locale("de");
    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Information zur Anmeldung"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          {this.props.state < 4 && <DialogContentText>Die Wunschliste wird am {moment(this.props.date, "DD.MM.YYYY").add(1, 'days').format('LL')} für das Zuteilungsverfahren an unser EDV-System übergeben. Je nach Auswahl der Veranstaltungen entstehen Ihnen ggf. Kosten. Bis zum Anmeldeschluss ({this.props.date}) können Sie die Wunschliste beliebig bearbeiten.</DialogContentText>}
          {this.props.state >= 4 && <DialogContentText>Wenn alle gewählten Programme in der Wunschliste abgelegt sind, fordern Sie bitte über den entsprechenden Button die Rechnung für Ihr Kind an.</DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} variant="contained" color="primary">Verstanden</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

FirstProgramInfoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  state: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withMobileDialog()(FirstProgramInfoDialog);
